<div class="flex-end-center gap-4">
  <div [class.placeholder]="isPlaceholder">
    {{ value }}
  </div>
  <div>{{ unit }}</div>
</div>
